import { CommonErrorModal } from "@app/components/modals/CommonErrorModal";
import { CAFE24_SCOPES } from "@app/pages/auth/platform/cafe24/Login";
import { Path } from "@app/route_path";
import { PlatformType } from "@app/types/platform";
import { CAFE24_CLIENT_ID } from "@app/utils/keys";
import { useModal } from "@shortsworks/ui";
import { useSigninWithPlatform, setAuthToken } from "@shortsworks/user-api";
import { LoaderCircle } from "lucide-react";
import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

export const SignupByCafe24 = () => {
  const { showModal } = useModal();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const mallId = searchParams.get("mall_id") as string;
  const shopListParam = searchParams.get("shop_list");

  const {
    data: signInWithPlatformData,
    isSuccess: isSuccessSignInWithPlatform,
    isError: isErrorSignInWithPlatform,
  } = useSigninWithPlatform(mallId);
  // cafe24 앱을 통해서 접근할 경우 받는 쿼리 목록
  const userType = searchParams.get("user_type");
  const hmac = searchParams.get("hmac");

  useEffect(() => {
    if (!mallId) {
      showModal(CommonErrorModal, { title: "잘못된 접근입니다." });
      return navigate(Path.LOGIN);
    }
    // 처음 접근 시 해당 mallId를 통한 권한 관련 작업 후 다시 이 페이지로 접근
    if (userType == "P" && hmac) {
      const redirectState = btoa(
        `${mallId}@${import.meta.env.VITE_FONTEND_URL}${Path.SIGNUP_CAFE24}?mall_id=${mallId}`,
      );
      const cafe24AuthRedirectURL = `https://${mallId}.cafe24.com/api/v2/oauth/authorize?response_type=code&client_id=${CAFE24_CLIENT_ID}&redirect_uri=${"https://api.shortsdev.com"}/external/auth/&state=${redirectState}&scope=${CAFE24_SCOPES}`;
      return location.assign(cafe24AuthRedirectURL);
    }

    // 이미 가입된 계정인 경우
    if (isSuccessSignInWithPlatform) {
      // @ts-ignore
      if (!signInWithPlatformData.data.accessToken) {
        return navigate(Path.SIGNUP, {
          state: {
            platformType: PlatformType.CAFE24,
            step: 2,
          },
        });
      }

      setAuthToken({
        // @ts-ignore
        accessToken: signInWithPlatformData.data.accessToken,
        // @ts-ignore
        refreshToken: signInWithPlatformData.data.refreshToken,
      });
      return navigate(Path.DASHBOARD);
    }

    // 가입되지 않은 계정인 경우
    if (isErrorSignInWithPlatform) {
      return navigate(Path.SIGNUP, {
        state: {
          platformType: PlatformType.CAFE24,
          step: 2,
          ...(shopListParam && {
            shopList: JSON.parse(window.atob(shopListParam.split("'")[1])),
          }),
        },
      });
    }
  }, [isSuccessSignInWithPlatform, isErrorSignInWithPlatform]);

  return (
    <div className="flex w-dvw h-dvh items-center justify-center">
      <LoaderCircle className="w-6 h-6 mr-2 animate-spin" />
    </div>
  );
};
